import { useContext, useEffect } from 'react';
import { WizardContext } from '../context/wizard-context';

export type WizardEffect = {
  backButtonEnabled: boolean;
  nextButtonEnabled: boolean;
  onNextButtonClicked: () => void;
  onBackButtonClicked: () => void;
  backButtonVisible: boolean;
  nextButtonVisible: boolean;
  nextButtonLabel: string;
  backButtonLabel: string;
  navigateBackEnabled: boolean;
  footerVisible: boolean;
  hideProgressBar: boolean;
  softDisable: boolean;
};

export type WizardHelpers = {
  setLoadingOverlayVisible;
};

export function useWizardEffect(
  getEffect: (helpers: WizardHelpers) => Partial<WizardEffect>,
  dependencyList: ReadonlyArray<any>,
) {
  const {
    setOnNextEventHandler,
    setOnBackEventHandler,
    handleNavigateNext,
    handleNavigateBack,
    setBackButtonEnabled,
    setNextButtonEnabled,
    setBackButtonLabel,
    setNextButtonLabel,
    setBackButtonVisible,
    setNextButtonVisible,
    setFooterVisible,
    isLoadingOverlayVisible,
    setLoadingOverlayVisible,
    setNavigateBackEnabled,
    setHideProgressBar,
    resetToDefaults,
    setSoftDisable,
  } = useContext(WizardContext);

  useEffect(() => {
    resetToDefaults();
    const wizardEffect: Partial<WizardEffect> = getEffect({ setLoadingOverlayVisible });
    wizardEffect.backButtonEnabled && setBackButtonEnabled(wizardEffect.backButtonEnabled);
    wizardEffect.nextButtonEnabled && setNextButtonEnabled(wizardEffect.nextButtonEnabled);
    wizardEffect.onNextButtonClicked && setOnNextEventHandler(wizardEffect.onNextButtonClicked);
    wizardEffect.onBackButtonClicked && setOnBackEventHandler(wizardEffect.onBackButtonClicked);
    wizardEffect.nextButtonVisible !== undefined &&
      setNextButtonVisible(wizardEffect.nextButtonVisible);
    wizardEffect.backButtonVisible !== undefined &&
      setBackButtonVisible(wizardEffect.backButtonVisible);
    wizardEffect.nextButtonLabel && setNextButtonLabel(wizardEffect.nextButtonLabel);
    wizardEffect.backButtonLabel && setNextButtonLabel(wizardEffect.backButtonLabel);
    wizardEffect.navigateBackEnabled !== undefined &&
      setNavigateBackEnabled(wizardEffect.navigateBackEnabled);
    wizardEffect.hideProgressBar !== undefined && setHideProgressBar(wizardEffect.hideProgressBar);
    wizardEffect.footerVisible !== undefined && setFooterVisible(wizardEffect.footerVisible);
    wizardEffect.softDisable !== undefined && setSoftDisable(wizardEffect.softDisable);
  }, dependencyList);

  return {
    setOnNextEventHandler,
    setOnBackEventHandler,
    handleNavigateNext,
    handleNavigateBack,
    setBackButtonEnabled,
    setNextButtonEnabled,
    setBackButtonLabel,
    setNextButtonLabel,
    setBackButtonVisible,
    setNextButtonVisible,
    setFooterVisible,
    isLoadingOverlayVisible,
    setLoadingOverlayVisible,
  };
}
